module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fb-Gc-Hc-Ic-Ja.b4be0c51.png";